import React from 'react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-16 pb-10 px-2 sm:px-6 lg:px-8" data-id="element-53">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] max-w-[100vw] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-54" />

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10 mt-[-50px] mb-[-50px]" data-id="element-55">
        <div className="inline-block mb-4 px-3 py-1 rounded-full border border-gold/30 bg-gold/5 text-gold-light text-sm font-medium tracking-wider capitalize pt-[4px] pb-[4px]" data-id="element-56">
          A Dream Interpretation System
        </div>

        <h1 className="text-[58px] sm:text-[72px] lg:text-[84px] font-bold tracking-tight mt-[0px] mb-[0px] leading-[0.85]" data-id="element-57">
          Decode Any
          <br data-id="element-58" />
          Dream in
          <br data-id="element-59" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-60">
            Minutes
          </span>
        </h1>

        {/* Product mockup */}
        <div className="relative w-full max-w-sm sm:max-w-md mb-0" data-id="element-61">
          <img src="https://cdn.magicpatterns.com/uploads/xe5QqmvYQYMzDYtLSnJ3RK/Diseno_sin_titulo_(27).webp" alt="The Dream Decoding System Product" className="w-full h-auto object-cover rounded-[32px] mt-[20px] mb-[20px] pl-[16px] pr-[16px]" loading="eager" decoding="async" fetchPriority="high" data-id="element-62" />
        </div>

        <p className="sm:text-2xl max-w-2xl font-light text-white/90 mt-[-16px] mb-[-16px] text-[18px]" data-id="element-63">
          A proven{' '}
          <span className="font-[700] text-[#FFD64D]" data-id="element-64">step-by-step system</span>
          <br data-id="element-65" />
          to{' '}
          <span className="text-white font-[600]" data-id="element-66">
            understand your dreams
          </span>{' '}
          and
          <br data-id="element-67" />
          get <span className="text-white font-[600]" data-id="element-68">clear answers</span> fast.
        </p>

        <div className="flex flex-col items-center space-y-0 mt-[16px] mb-[16px]" data-id="element-69">
          <Button href="#checkout" className="w-full sm:w-auto min-w-[280px]" data-id="element-70">
            Get Instant Access
          </Button>
          <p className="text-sm text-zinc-500 flex items-center gap-2 mt-2 mb-0" data-id="element-71">
            <span data-id="element-72">One-time payment</span>
            <span className="w-1 h-1 rounded-full bg-zinc-600" data-id="element-73"></span>
            <span data-id="element-74">Lifetime access</span>
          </p>
        </div>
      </div>
    </section>;
}